import React, { Component, Fragment } from 'react';
import AboutMe from "../components/about/aboutMe";
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';
class About extends Component {
    render() {

        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <AboutMe />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default About;